import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/utils';
import { Captcha as FTTBCaptcha } from '@fttb/common';
import { selectCaptchaRequired, selectIsCaptchaError, selectRefreshCaptcha } from "../../../../store/callbackRequest/selectors";
import { selectCaptchaTexts } from "../../../../store/blocks/addressVerification/selectors";
import { setCaptchaKey, setCaptchaValue, setIsCaptchaError, setRefreshCaptcha } from "../../../../store/callbackRequest/slice";
export var _Captcha = function _Captcha(_ref) {
  var onChangeCaptcha = _ref.onChangeCaptcha,
    handleCaptchaError = _ref.handleCaptchaError,
    handleRefreshCaptcha = _ref.handleRefreshCaptcha,
    isCaptchaError = _ref.isCaptchaError,
    setCaptchakey = _ref.setCaptchakey,
    refreshToken = _ref.refreshToken,
    texts = _ref.texts;
  return /*#__PURE__*/React.createElement(FTTBCaptcha, {
    handleErrorStatus: handleCaptchaError,
    isError: isCaptchaError,
    onChange: onChangeCaptcha,
    onRefresh: handleRefreshCaptcha,
    refreshToken: refreshToken,
    setCaptchakey: setCaptchakey,
    texts: texts,
    "data-t-id": "components-Captcha"
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: selectCaptchaRequired(state),
    isCaptchaError: selectIsCaptchaError(state),
    refreshToken: selectRefreshCaptcha(state),
    texts: selectCaptchaTexts(state)
  };
};
var mapDispatchToProps = {
  onChangeCaptcha: setCaptchaValue,
  handleCaptchaError: setIsCaptchaError,
  handleRefreshCaptcha: setRefreshCaptcha,
  setCaptchakey: setCaptchaKey
};
var connector = connect(mapStateToProps, mapDispatchToProps);
export var Captcha = compose(connector, withRenderFlag)(_Captcha);